export const SET_PREVIOUS_TEAM = "SET_PREVIOUS_TEAM";
export const SET_ROUNDS = "SET_ROUNDS";
export const SET_CURRENT_ROUND_ID = "SET_CURRENT_ROUND_ID";